<template>
    <div class="container">
        <div class="grid">
            <div class="col-3">
                <!-- Sifre olustur -->
                <Card class="centered" :style="{ width: '20vw' }" v-if="SayfaDurum">
                    <template #title>
                        <div class="grid">
                            <div class="col-12 flex justify-content-center flex-wrap">
                                Şifre Yenile
                            </div>
                        </div>
                    </template>
                    <template #content>
                        <div class="grid">
                            <div class="col-12">
                                <InputGroup>
                                    <InputGroupAddon>
                                        <i class="pi pi-key"></i>
                                    </InputGroupAddon>
                                    <Password id="YeniSifre" placeholder="Yeni Şifre" v-model="YeniSifre" autofocus :disabled="IslemYapiliyor"
                                        :invalid="this.Valid.YeniSifre" toggleMask :feedback="false" />
                                </InputGroup>
                            </div>
                            <div class="col-12">
                                <InputGroup>
                                    <InputGroupAddon>
                                        <i class="pi pi-key"></i>
                                    </InputGroupAddon>
                                    <Password id="YeniSifreTekrar" placeholder="Yeni Şifre Tekrar"
                                        v-model="YeniSifreTekrar" autofocus :invalid="this.Valid.YeniSifreTekrar" :disabled="IslemYapiliyor"
                                        toggleMask :feedback="false" />
                                </InputGroup>
                            </div>
                            <div class="col-12 flex justify-content-center flex-wrap">
                                <Button @click="this.handleClick()" label="Gönder" class="m-2" />
                            </div>
                        </div>
                    </template>
                </Card>

                <!-- Daha önce kullanılmış -->
                <Card class="centered" :style="{ width: '20vw' }" v-if="!SayfaDurum">
                    <template #title>
                        <div class="grid">
                            <div class="col-12 flex justify-content-center flex-wrap">
                                Lütfen tekrar deneyin.
                            </div>
                        </div>
                    </template>
                    <template #content>
                        <div class="grid">
                            <div class="col-12">
                                Bu linkin süresi dolmuş ve ya daha önce kullanılmış.
                            </div>
                        </div>
                    </template>
                </Card>
            </div>
        </div>
    </div>
</template>

<script>
import GlobalServis from "../../../../services/GlobalServis";
export default {
    data() {
        return {
            SayfaDurum: true,
            IslemYapiliyor: false,
            YeniSifre: "",
            YeniSifreTekrar: "",
            //--------------
            // Validation Elements
            Valid: {
                YeniSifre: false,
                YeniSifreTekrar: false,
            }
        };
    },
    methods: {
        handleClick() {
            if (this._FormCheck()) { return; }
            this.IslemYapiliyor = true;
            if (this.YeniSifre != this.YeniSifreTekrar) {
                this.Valid.YeniSifre = true;
                this.Valid.YeniSifreTekrar = true;
                this.$toast.add({
                    severity: "warn",
                    summary: "Uyaru",
                    detail: "Şifreler aynı değil",
                    life: 3000,
                });
                return;
            }

            let data = {
                LinkGuid: this.$route.query.id,
                YeniSifre: this.YeniSifre,
                YeniSifreTekrar: this.YeniSifreTekrar
            };

            GlobalServis.GlobalServis("POST", "UpdateSifreDegistir", data).then((res) => {
                if (res.status == 200) {
                    //
                } else if (res.response.status === 999) {
                    this.$toast.add({
                        severity: "info",
                        summary: "Bilgi",
                        detail: res.response.data,
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Hata oldu",
                        life: 3000,
                    });
                }
            })
        },
        _GetLinkGuidKontrol() {
            let data = {
                LinkGuid: this.$route.query.id,
            };

            GlobalServis.GlobalServis("POST", "GetGuidKontrol", data).then((res) => {
                if (res.status == 200) {
                    //
                } else if (res.response.status === 999) {
                    if (res.response.data == "AKTIF") {
                        this.SayfaDurum = true;
                    }
                    else if (res.response.data == "PASIF") {
                        this.SayfaDurum = false;
                    }
                    else {
                        this.$router.push({ path: "/NotFound" })
                    }
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Hata oldu",
                        life: 3000,
                    });
                }
            })
        },
        _FormCheck() {
            // let Check = false;
            // if (this.MailAdres === "") {
            //     this.Valid.MailAdres = true;
            //     this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Mail adresi girin", life: 3000, });
            //     Check = true;
            //     return Check;
            // } else { this.Valid.MailAdres = false; Check = false; }
        },
    },
    created() {
        if (this.$route.query.id == "" || typeof (this.$route.query.id) === "undefined") {
            this.$router.push({ path: "/NotFound" })
        }
        this._GetLinkGuidKontrol()
    },
    components: {

    }
};
</script>
<style scoped>
.container {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: #cdd4cd;
}

.centered {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
}
</style>